import styled from "styled-components";

export const Logo = ({ small }) => (
  <LogoContainer>
    <LogoSub small={small}>Mats & Tess</LogoSub>
    <LogoTitle small={small}>REISBLOG</LogoTitle>
    <LogoLine small={small} />
  </LogoContainer>
)

const LogoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const LogoSub = styled.span`
    font-family: Quicksand;
    font-weight: 400;
    color: #fff;
    font-size: ${props => props.small ? '1rem' : '2.5rem'};
    text-shadow: ${props => props.small ? '1px 1px #000' : 'none' };
    margin: 0;
`;

const LogoTitle = styled.span`
    font-family: Lora;
    font-weight: bold;
    color: #fff;
    font-size: ${props => props.small ? '1.8rem' : '4rem'};
    text-shadow: ${props => props.small ? '1px 1px #000' : 'none' };
    margin: 0;
`;

const LogoLine = styled.div`
    height: ${props => props.small ? '2px' : '3px'};
    width: ${props => props.small ? '50px' : '70px'};
    background-color: white;
    margin-top: ${props => props.small ? '-5px' : '-10px'};
`;